export default __webpack_public_path__ + "static/iconography-image-a-97eef736ba3d6c541d9fae935bcd6dbc60fefc9619cfa57aa9867135fc6f8182.png";